module.exports = __webpack_public_path__ + "media/images/brand/bg-osekkai-technology-bd532b1acdfc85654f14242159121a15.png";